import request from '@/utils/request'
// 获取商品列表
export function getGoodsList(data) {
    return request({
        // url: '/sdk/api/gw/account/pay/getGoodsList',
        url: '/webshop/api/shop/getInfo',
        method: 'get',
        params: data
    })
}

//  创建订单
export function createOrder(data) {
    return request({
        url: '/sdk/api/gw/account/pay/createOrder',
        method: 'post',
        data
    })
}

// 预支付
export function payAdvance(data) {
    return request({
        url: '/sdk/api/gw/account/pay/advance',
        method: 'GET',
        params:data
    })
}

// 支付
export function payDo(data) {
    return request({
        url: '/sdk/api/gw/account/pay/do',
        method: 'post',
        data
    })
}

// 获取商品真实金额
export function getRealAmount(data) {
    return request({
        url: '/sdk/api/gw/account/pay/getRealAmount',
        method: 'get',
        params:data
    })
}

// 订单状态查询
export function getOrderState(data) {
    return request({
        url: '/sdk/api/v1/pay/unifiedCheck',
        method: 'get',
        params:data
    })
}


// 获取支付方式宣传详情
export function getPayChannelInfo(data) {
    return request({
        url: '/sdk/api/gw/account/pay/getPayChannelInfo',
        method: 'get',
        params:data
    })
}


// 签到礼包
export function receiveGift(data) {
    return request({
        url: '/webshop/api/shop/receiveGift',
        method: 'post',
        data
    })
}

// 兑换
export function submitDuihuan(data) {
    return request({
        url: '/webshop/api/shop/mlbb/pointExchange',
        method: 'post',
        data
    })
}

// 公告
export function getGameNotice(data) {
    return request({
        url: '/webshop/api/gw/web/getGameNotice',
        method: 'get',
        params:data
    })
}



// WEBPACK FOOTER //
// ./src/api/recharge.js